import { CrossClientQueryDataSource, CrossClientQueryInitializedExecution, CrossClientQueryLogicalQuestionDecomposition } from '../../models/CrossClient'
import { BaseRequest } from '../models'
import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithTokenRefresh } from '../../common/baseQuery'

const _TRANSCRIPTION_SERVICE_BASE_URL = import.meta.env.REACT_APP_AI_EXECUTE_API_BASE_URL!

interface CrossClientQueryInitializeRequest extends BaseRequest {
  payload: {
    ownerId: string
    userQuestion: string
    clientIds?: string[]
    decomposition?: CrossClientQueryLogicalQuestionDecomposition
  }
}

interface CrossClientQueryEvaluateRequest extends BaseRequest {
  executionId: string
  payload: {
    sources: CrossClientQueryDataSource[]
  }
}

interface CrossClientQueryCancelRequest extends BaseRequest {
  executionId: string
}

export const crossClientExecutionApi = createApi({
  reducerPath: 'crossClientExecutionApi',
  baseQuery: baseQueryWithTokenRefresh(_TRANSCRIPTION_SERVICE_BASE_URL),
  endpoints: (builder) => ({
    initializeCrossClientQuery: builder.mutation<CrossClientQueryInitializedExecution, CrossClientQueryInitializeRequest>({
      query: ({ accountId, payload }) => ({
        url: `/accounts/${accountId}/cross-client-query/initialize`,
        method: 'POST',
        body: payload,
      }),
      transformResponse: (response: { data: CrossClientQueryInitializedExecution }) => response.data,
    }),
    evaluateCrossClientQuery: builder.mutation<null, CrossClientQueryEvaluateRequest>({
      query: ({ accountId, executionId, payload }) => ({
        url: `/accounts/${accountId}/cross-client-query/${executionId}/evaluate`,
        method: 'POST',
        body: payload,
      }),
    }),
    cancelCrossClientQuery: builder.mutation<null, CrossClientQueryCancelRequest>({
      query: ({ accountId, executionId }) => ({
        url: `/accounts/${accountId}/cross-client-query/${executionId}/cancel`,
        method: 'POST',
      }),
    }),
  }),
})

export const { useInitializeCrossClientQueryMutation, useEvaluateCrossClientQueryMutation, useCancelCrossClientQueryMutation } = crossClientExecutionApi
